import { forwardRef, useEffect, useState } from "react";
import { PasswordInputProps } from "./Common";
import InputBox from "./InputBox";

const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,64}$/;

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>((props: PasswordInputProps, ref) => {
  const [hasValidationErrors, setHasValidationErrors] = useState(false);

  const hasErrors = (value: string | null | number) => {
    if (!props.showValidationErrors) {
      return false;
    }

    if (!props.required) {
      return false;
    }

    if (!value?.toString()?.trim()) {
      return true;
    }

    const isMatch = value.toString().match(PASSWORD_REGEX);
    return !isMatch;
  }

  useEffect(() => {
    setHasValidationErrors(hasErrors(props.value));
  }, [props.value]);
  
  return <div>
    <InputBox
      ref={ref}
      type="password"
      {...props}
      onKeyDown={(event) => {
        if (event.key === "Enter" && props.onEnterPress) {
          props.onEnterPress();
        }
      }}
      onChange={(event) => {
        const hasError = hasErrors(event.target.value);
        props.onChange(event.target.value, hasError);
      }}
      hasValidationErrors={hasValidationErrors} />

    {
      props.showValidationErrors && hasValidationErrors && !props.isPasswordConfirmation &&
      <div className="text-error-contrast text-sm">Must be between 8 and 64 characters, including 1 lower case (a-z), 1 upper case (A-Z), 1 special character (@#$%^&*) and 1 number (0-9).</div>
    }
    {
      props.isPasswordConfirmation && props.value != props.confirmationPassword &&
      <div className="text-error-contrast text-sm">Confirmation password does not match.</div>
    }
  </div>
});

export default PasswordInput;